<mat-sidenav-container fullscreen>
    <mat-sidenav
        mode="side"
        (mouseover)="openNavigationMenu()"
        (mouseleave)="closeNavigationMenu()"
        opened
        [ngStyle]="{ width: navigationMenuWidth + 'px' }"
    >
        <div class="navigation-list">
            <div
                *ngIf="!isNavigationMenuOpen"
                class="navigation-item navigation-item--main navigation-item--main-icon"
            >
                <mat-icon>keyboard_double_arrow_right</mat-icon>
            </div>

            <div
                *ngIf="isNavigationMenuOpen"
                class="navigation-item navigation-item--main navigation-item--main-opened"
            >
                <div class="blumepress-header">
                    <!-- <mat-icon svgIcon="logo-v"></mat-icon> -->
                    <img
                        src="./../../../assets/icons/logo-v.svg"
                        height="40px"
                    />
                    <!-- <span class="blumepress-header--text">Blumepress</span> -->
                </div>
            </div>
            <div class="navigation-items">
                <div
                    class="navigation-items--navigation-item"
                    *ngFor="let navigationItem of filteredNavigationItems"
                >
                    <div class="navigation-items--icon-container">
                        <a
                            [routerLink]="navigationItem.routerLink"
                            routerLinkActive="navigation-item--active"
                            [class.disabled]="navigationItem.isDisabled"
                        >
                            <mat-icon
                                *ngIf="!navigationItem.matIcon"
                                class="navigation-items--icon"
                                [svgIcon]="navigationItem.svgIcon"
                            ></mat-icon>
                            <mat-icon
                                *ngIf="navigationItem.matIcon"
                                class="navigation-items--icon"
                            >
                                {{ navigationItem.matIcon }}
                            </mat-icon>
                            <div
                                *ngIf="isNavigationMenuOpen"
                                class="navigation-items--icon-text"
                            >
                                {{ navigationItem.title | titlecase }}
                            </div>
                        </a>
                        <mat-icon
                            *ngIf="
                                isNavigationMenuOpen &&
                                navigationItem.children &&
                                !navigationItem.viewExpanded
                            "
                            class="navigation-items--icon navigation-items--navigation-item__expand-icon"
                            (click)="navigationItem.viewExpanded = true"
                        >
                            expand_more
                        </mat-icon>
                        <mat-icon
                            *ngIf="
                                isNavigationMenuOpen &&
                                navigationItem.children &&
                                navigationItem.viewExpanded
                            "
                            class="navigation-items--icon navigation-items--navigation-item__expand-icon"
                            (click)="navigationItem.viewExpanded = false"
                        >
                            expand_less
                        </mat-icon>
                    </div>
                    <div
                        class="navigation-items--navigation-child-container"
                        *ngIf="
                            isNavigationMenuOpen &&
                            navigationItem.children &&
                            navigationItem.viewExpanded
                        "
                    >
                        <div
                            class="navigation-items--navigation-child-item"
                            *ngFor="
                                let childNavigationItem of navigationItem.children
                            "
                        >
                            <a
                                [routerLink]="childNavigationItem.routerLink"
                                routerLinkActive="navigation-item--active"
                                [class.disabled]="
                                    childNavigationItem.isDisabled
                                "
                            >
                                {{ childNavigationItem.title | titlecase }}
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="flex-spacer"></div>
            <div *ngIf="isNavigationMenuOpen" class="navigation-footer">
                <div class="navigation-footer--main">
                    Blumepress &copy; {{ currentYear }}
                </div>
                <div class="navigation-footer--sub">Copyright • Privacy</div>
            </div>
        </div>
    </mat-sidenav>
    <mat-sidenav-content
        [ngStyle]="{ 'margin-left.px': sidenavContentLeftMargin }"
    >
        <mat-toolbar class="main-header">
            <div class="main-header--heading">
                <mat-icon
                    class="main-header--heading-icon"
                    svgIcon="blumepress"
                ></mat-icon>
                <span class="main-header--heading-text">
                    {{ currentRoute | titlecase }}
                </span>
            </div>

            <div class="flex-spacer"></div>
            <div style="margin-right: 10px">
                <button
                    mat-mini-fab
                    *ngIf="
                        entitlements.enablePressroom &&
                        pressroomId &&
                        pressroomId !== 'noPressroom'
                    "
                    color="primary"
                    aria-label="Live Pressroom Site"
                    matTooltip="Open live pressroom site"
                    style="cursor: pointer"
                    (click)="goToLiveSite()"
                >
                    <mat-icon color="accent">open_in_new</mat-icon>
                </button>
            </div>

            <!-- Account Selector -->
            <div class="acct-trigger" [matMenuTriggerFor]="accountMenuDiv">
                <span class="acct-trigger__avatar">
                    {{ $any(accountName | slice: 0 : 1) | uppercase }}
                </span>
                <span class="acct-trigger__name" [matTooltip]="accountName">
                    {{ accountName | slice: 0 : 24
                    }}{{ accountName.length > 24 ? '…' : '' }}
                </span>
                <mat-icon class="acct-trigger__arrow">expand_more</mat-icon>
            </div>

            <mat-menu #accountMenuDiv="matMenu" class="acct-panel">
                <div class="acct-menu" (click)="$event.stopPropagation()">
                    <div class="acct-menu__header">
                        <mat-icon class="acct-menu__header-icon">
                            business
                        </mat-icon>
                        <span class="acct-menu__header-label">Accounts</span>
                    </div>
                    <div class="acct-menu__list">
                        <ng-container *ngFor="let account of accountMenu">
                            <!-- Account with pressrooms -->
                            <button
                                *ngIf="account.pressrooms.length > 0"
                                class="acct-menu__item"
                                mat-menu-item
                                [matMenuTriggerFor]="pressroomMenu"
                            >
                                <span
                                    class="acct-menu__item-avatar"
                                    [class.acct-menu__item-avatar--active]="
                                        currentAccount === account.id
                                    "
                                >
                                    {{
                                        $any(account.name | slice: 0 : 1)
                                            | uppercase
                                    }}
                                </span>
                                <span
                                    class="acct-menu__item-name"
                                    [class.acct-menu__item-name--active]="
                                        currentAccount === account.id
                                    "
                                    [matTooltip]="account.name"
                                >
                                    {{ account.name | slice: 0 : 20
                                    }}{{ account.name.length > 20 ? '…' : '' }}
                                </span>
                                <mat-icon
                                    *ngIf="currentAccount === account.id"
                                    class="acct-menu__item-check"
                                >
                                    check_circle
                                </mat-icon>
                                <mat-icon class="acct-menu__item-arrow">
                                    chevron_right
                                </mat-icon>
                            </button>

                            <!-- Account without pressrooms -->
                            <button
                                *ngIf="account.pressrooms.length === 0"
                                class="acct-menu__item"
                                mat-menu-item
                                (click)="
                                    updatePressroom(account.id, 'noPressroom')
                                "
                            >
                                <span
                                    class="acct-menu__item-avatar"
                                    [class.acct-menu__item-avatar--active]="
                                        currentAccount === account.id
                                    "
                                >
                                    {{
                                        $any(account.name | slice: 0 : 1)
                                            | uppercase
                                    }}
                                </span>
                                <span
                                    class="acct-menu__item-name"
                                    [class.acct-menu__item-name--active]="
                                        currentAccount === account.id
                                    "
                                    [matTooltip]="account.name"
                                >
                                    {{ account.name | slice: 0 : 20
                                    }}{{ account.name.length > 20 ? '…' : '' }}
                                </span>
                                <mat-icon
                                    *ngIf="currentAccount === account.id"
                                    class="acct-menu__item-check"
                                >
                                    check_circle
                                </mat-icon>
                            </button>

                            <!-- Pressroom Submenu -->
                            <mat-menu #pressroomMenu="matMenu" class="pr-panel">
                                <div class="pr-menu">
                                    <div class="pr-menu__header">
                                        <mat-icon class="pr-menu__header-icon">
                                            web
                                        </mat-icon>
                                        <span class="pr-menu__header-label">
                                            Pressrooms
                                        </span>
                                    </div>
                                    <button
                                        *ngFor="let pr of account.pressrooms"
                                        class="pr-menu__item"
                                        mat-menu-item
                                        (click)="
                                            updatePressroom(account.id, pr.id)
                                        "
                                    >
                                        <mat-icon
                                            class="pr-menu__item-icon"
                                            [class.pr-menu__item-icon--active]="
                                                pr.id === pressroomId &&
                                                currentAccount === account.id
                                            "
                                        >
                                            {{
                                                pr.id === pressroomId &&
                                                currentAccount === account.id
                                                    ? 'radio_button_checked'
                                                    : 'radio_button_unchecked'
                                            }}
                                        </mat-icon>
                                        <span
                                            class="pr-menu__item-name"
                                            [class.pr-menu__item-name--active]="
                                                pr.id === pressroomId &&
                                                currentAccount === account.id
                                            "
                                            [matTooltip]="pr.name"
                                        >
                                            {{ pr.name | slice: 0 : 20
                                            }}{{
                                                pr.name.length > 20 ? '…' : ''
                                            }}
                                        </span>
                                        <span
                                            *ngIf="pr.country"
                                            style="
                                                margin-left: 6px;
                                                color: #9a9a9a;
                                                font-size: 0.85em;
                                            "
                                        >
                                            ({{ pr.country }})
                                        </span>
                                    </button>
                                    <button
                                        *ngIf="account.pressrooms.length === 0"
                                        class="pr-menu__item"
                                        mat-menu-item
                                        (click)="
                                            updatePressroom(
                                                account.id,
                                                'noPressroom'
                                            )
                                        "
                                    >
                                        <mat-icon class="pr-menu__item-icon">
                                            {{
                                                pressroomId === 'noPressroom' ||
                                                currentAccount === account.id
                                                    ? 'radio_button_checked'
                                                    : 'radio_button_unchecked'
                                            }}
                                        </mat-icon>
                                        <span class="pr-menu__item-name">
                                            No Pressroom
                                        </span>
                                    </button>
                                </div>
                            </mat-menu>
                        </ng-container>
                    </div>
                </div>
            </mat-menu>

            <!-- User Menu Trigger -->
            <div class="user-menu" [matMenuTriggerFor]="userAccount">
                <span class="user-menu--text">{{ fullName | titlecase }}</span>
                <span class="user-menu--avatar">
                    {{ userName | uppercase }}
                </span>
            </div>

            <!-- User Menu Dropdown -->
            <mat-menu #userAccount="matMenu" class="user-menu-panel">
                <div class="um" (click)="$event.stopPropagation()">
                    <!-- Profile Card -->
                    <div class="um__profile">
                        <div class="um__avatar-wrapper">
                            <div class="um__avatar">
                                {{ userName | uppercase }}
                            </div>
                        </div>
                        <div class="um__info">
                            <span class="um__name">
                                {{ fullName | titlecase }}
                            </span>
                            <span class="um__email">{{ emailId }}</span>
                        </div>
                    </div>

                    <!-- Email Auditor -->
                    <ng-container *ngIf="entitlements.enablePressroom">
                        <div class="um__sep"></div>
                        <div class="um__auditor">
                            <div class="um__auditor-head">
                                <mat-icon class="um__auditor-icon">
                                    forward_to_inbox
                                </mat-icon>
                                <span class="um__auditor-label">
                                    Email Auditor
                                </span>
                                <div class="um__auditor-tools">
                                    <mat-icon
                                        class="um__tool-icon"
                                        matTooltip="Send an email to the address below to add a new press release from any mailbox, such as Gmail, Yahoo, AOL, etc. It may take up to 10 minutes for the email release to appear in the content manager."
                                        matTooltipClass="small-tooltip-fonts"
                                        matTooltipPosition="left"
                                    >
                                        info_outline
                                    </mat-icon>
                                    <mat-icon
                                        class="um__tool-icon"
                                        *ngIf="isAdminOrSuperAdminOrModerator"
                                        (click)="openEmailConfig()"
                                        matTooltip="Email configuration"
                                    >
                                        tune
                                    </mat-icon>
                                    <mat-icon
                                        class="um__tool-icon"
                                        *ngIf="
                                            pressroomId !== '' &&
                                            pressroomId !== 'noPressroom'
                                        "
                                        (click)="copyEmail(emailListener)"
                                        matTooltip="Copy email address"
                                    >
                                        content_copy
                                    </mat-icon>
                                </div>
                            </div>
                            <div
                                *ngIf="
                                    pressroomId !== '' &&
                                    pressroomId !== 'noPressroom'
                                "
                                class="um__auditor-email"
                            >
                                <a
                                    class="um__email-link"
                                    href="mailto:{{ emailListener }}"
                                >
                                    {{ emailListener }}
                                </a>
                            </div>
                            <div
                                *ngIf="
                                    pressroomId === '' ||
                                    pressroomId === 'noPressroom'
                                "
                                class="um__auditor-empty"
                            >
                                <mat-icon class="um__empty-icon">
                                    info_outline
                                </mat-icon>
                                <span>No pressroom selected</span>
                            </div>
                        </div>
                    </ng-container>

                    <!-- Actions -->
                    <div class="um__sep"></div>
                    <div class="um__actions">
                        <button
                            class="um__action"
                            mat-menu-item
                            (click)="changePassword()"
                        >
                            <mat-icon>lock_outline</mat-icon>
                            <span>Change Password</span>
                        </button>
                        <button
                            class="um__action um__action--danger"
                            mat-menu-item
                            (click)="logout()"
                        >
                            <mat-icon>logout</mat-icon>
                            <span>Sign Out</span>
                        </button>
                    </div>
                </div>
            </mat-menu>
        </mat-toolbar>
        <ng-content></ng-content>
    </mat-sidenav-content>
</mat-sidenav-container>
